<template>
    <CompassDialog
        :visible.sync="visible"
        :title="title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="handleCancel"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ message }}
        </p>
    </CompassDialog>
</template>

<script>
import { deleteEmailTemplate } from 'api/emailEngine/emailEngineService';

export default {
    props: {
        template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            visible: true,
            title: this.$t.__('email.SettingsEmailsTemplatesDeleteModal.title'),
            message: this.$t.__('email.SettingsEmailsTemplatesDeleteModal.message'),
            parentVue: this.$parent.$refs.settingsEmailsTemplatesRef.__vue__,
            isLoading: false,
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__('common.actions.delete'),
                type: 'primary-destructive',
                loading: this.isLoading,
                action: () => this.removeTemplate(),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => this.handleCancel(),
                },
            ];
        },
    },
    methods: {
        removeTemplate() {
            this.isLoading = true;
            deleteEmailTemplate(this.template.id)
                .then(() => {
                    this.parentVue.getTemplates();
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$t.__(
                            'email.SettingsEmailsTemplates.success_text_delete_template',
                        ),
                        close: true,
                    });
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$t.__(
                            'email.SettingsEmailsTemplates.error_text_duplicate_template',
                        ),
                        close: true,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.parentVue.showDeleteModal = false;
                    this.$emit('close');
                });
        },
        handleCancel() {
            this.parentVue.showDeleteModal = false;
            this.$emit('close');
        },
    },
};
</script>
